import {h, Fragment} from "preact"
import { useState } from "preact/hooks"

export default function Select({ value, onChange, className, options, label }) {
    const [active, setActive] = useState(true)

    return (
        <li className={`ns-sidebar-dropdown  ns-sort-by ${active ? "ns-active" : ""}`} >
           <span class="ns-anchor ns-d-inline-block ns-relative ns-w-100 ns-border-box" onClick={() => setActive(!active)}>
                <span class="ns-facet-name">Sort by</span>
           </span>
           <div class="ns-sidebar-submenu ns-d-none">
                <ul class="ns-list-unstyled ns-p-0 ns-m-0" role="menu" value={value}>
                    {options.map(option => (
                        <li 
                            class="ns-d-flex ns-justify-content-between ns-align-items-center ns-facet-li" 
                            key={option.value} 
                        >
                            <label 
                              class="ns-checkbox ns-d-block ns-color-black undefined"
                              sortValue={option.value} 
                              onClick={onChange}
                            >
                                {option.label}
                                {option.value == value ? ( <input type="checkbox" checked /> ) : ( <input type="checkbox" /> )}
                                <span class="ns-checkmark" onClick={(e) => {e.preventDefault(); onChange}}></span>
                            </label>
                            
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
}
